<template>
  <div class="map-layout">
    <NavBar></NavBar>
    <div id="map">
      <router-view/>
      <div class="version">
        <span>{{ version }}</span>
      </div>
    </div>
    <div class="sky-repeat"></div>
    <HubPopup></HubPopup>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import HubPopup from '@/components/HubPopup'
import { mapActions } from 'vuex'

export default {
  name: 'MapLayout',
  components: {
    NavBar,
    HubPopup
  },
  computed: {
    version () {
      const version = process.env.VERSION
      return this.$t('VERSION', { version })
    }
  },
  methods: {
    ...mapActions('map', [
      'initiateMap'
    ])
  },
  mounted () {
    this.initiateMap()
  }
}
</script>

<style scoped lang="sass">
#map
  width: 100%
  height: calc(100% - 46px)
  position: absolute
  background: #F0F0F0
  cursor: -webkit-grab
  *
    cursor: default

.version
  position: absolute
  text-align: right
  z-index: 1
  left: 8px
  bottom: 10px
  height: 14px
  padding: 0 5px
  white-space: nowrap
  color: #fff
  font-weight: bold
  font-size: 14px

.sky-repeat
  background: url(../assets/images/sky-repeat.svg)
  height: 250px
  position: absolute
  width: 100%
  bottom: 10px
  pointer-events: none
</style>
